import { render, staticRenderFns } from "./_socialButton.vue?vue&type=template&id=2f75f3c8&"
import script from "./_socialButton.vue?vue&type=script&lang=js&"
export * from "./_socialButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f75f3c8', component.options)
    } else {
      api.reload('2f75f3c8', component.options)
    }
    module.hot.accept("./_socialButton.vue?vue&type=template&id=2f75f3c8&", function () {
      api.rerender('2f75f3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ActionToolbar/Scripts/Buttons/_socialButton.vue"
export default component.exports